import {z} from 'zod';
import {zDateTime, zNumberToString} from '@brunata-angular/util';
import {DateTime} from 'luxon';

export const monitoringMeterBaseSchema = z
    .object({
        meterId: zNumberToString,
        meterNo: z.string(),
        meterSuperTypeNo: zNumberToString,
        meterModel: z
            .string()
            .nullable()
            .transform(value => value ?? ''),
        placement: z
            .string()
            .nullable()
            .transform(value => value ?? ''),
        mountingDate: zDateTime.nullable(),
        dismountedDate: zDateTime.nullable(),
        address: z
            .string()
            .nullable()
            .transform(value => value ?? ''),
        propertyNo: z
            .string()
            .nullable()
            .transform(value => value ?? ''),
        branchNo: z
            .string()
            .nullable()
            .transform(value => value ?? ''),
        locationNo: z
            .string()
            .nullable()
            .transform(value => value ?? ''),
        consumerName: z
            .string()
            .nullable()
            .transform(value => value ?? ''),
        alloUnitType: z.string(),
        unit: zNumberToString,
        meterSequenceNo: zNumberToString,
        printedSerialNo: z.string().nullable().optional(),
        replacedByMeterId: z.string().nullable(),
        replacedBy: z.string().nullable(),
        meterCriteriaMismatch: z.boolean(),
    })
    .extend({
        criteriaMismatchTranslation: z.string().optional(),
    })
    .transform(data => ({
        ...data,
        supportedConsumptionToMonitor: {
            // filter dismounted meters (not planned dismount, i.e. dismounts in the future)
            INDIVIDUALCONSUMPTION:
                data.dismountedDate === null || data.dismountedDate > DateTime.now(),
            // filter none
            SUMMEDCONSUMPTION: true,
            // filter none
            DIFFERENCECONSUMPTION: true,
        },
    }));

export type MonitoringMeterBase = z.infer<typeof monitoringMeterBaseSchema>;

export type MonitoringMeterWithTranslations = MonitoringMeterBase & {
    usageAndUnit: string;
};
